<template>
  <div class="top-nav">
    <div class="top-nav__content">
      <slot name="header"></slot>
    </div>
    <div class="top-nav__menu">
      <img
        v-if="userInfo.avatar"
        :src="userInfo.avatar"
        class="avatar headerImg"
      >
      <span
        v-else
        class="b-icon-avatar headerImg headerIcon"
      ></span>
      <el-dropdown @command="handleDropdown">
        <span class="el-dropdown-link">
          <span class="userName">{{ userName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="change-password"
          >
            <span class="font">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item
            divided
            command="sign-out"
          >
            <span class="font">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { signOut } from 'index/api'
import {
  UPDATE_USER_INFO
} from 'index/store/mutation-types'
export default {
  name: 'TopNav',
  data () {
    return {
      unread: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    userName () {
      // 优先显示真实姓名
      return this.userInfo.name || this.userInfo.username
    },
    avatar () {
      return this.userInfo.avatar
    }
  },
  watch: {
    userInfo: {
      handler (value) {
        Object.assign(value)
      },
      deep: true
    }
  },
  mounted () {
    if (!this.userName) {
      this.$store.dispatch(UPDATE_USER_INFO)
    }
  },
  methods: {
    handleDropdown (name) {
      switch (name) {
        case 'userInfo':
          this.$router.push('/userInfo')
          break
        case 'change-password':
          this.$router.push('/change-password')
          break
        case 'sign-out':
          signOut().then(() => {
            localStorage.removeItem('ACCESS_TOKEN')
            localStorage.removeItem('ccurrentId')
            window.location.href = '/'
          }).finally(() => {
            localStorage.removeItem('ACCESS_TOKEN')
            localStorage.removeItem('ccurrentId')
            window.location.href = '/'
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
  $top-nav-height: 68px;
  .top-nav {
    position: relative;
    display: flex;
    width: 100%;
    height: $top-nav-height;
    line-height: height;
    background-color: #ecf0f5;
    color: #43555e;
    font-size: 20px;
    &__content {
      flex: 1 1 auto;
    }
    &__menu {
      font-weight: normal;
      margin-right: 20px;
      line-height: 68px;
      @include clearfix;
      span {
        float: left;
      }
      .headerImg {
        font-size: 30px;
        margin: 20px 10px 0 12px;
      }
      .headerIcon {
        margin: 0 10px 0 12px;
      }
      .avatar {
        float: left;
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .bell {
        position: relative;
        cursor: pointer;
        float: left;
        font-size: 18px;
        .newInfo {
          position: absolute;
          top: 23px;
          right: 0;
          width: 8px;
          height: 8px;
          background: #f00;
          border-radius: 50%;
        }
      }
      .userName {
        float: left;
        max-width: 105px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-dropdown-menu__item {
        span {
          display: inline-block;
        }
        .font {
          font-size: 20px !important;
          color: #687284;
          margin-right: 15px;
        }
        .icon {
          font-size: 14px !important;
          color: #687284;
        }
      }
    }
  }
</style>
